import { browserSessionStorage } from "@/react/lib/browserStorage";
export const PREVIEW_MODAL_KEY = "showPreviewModal";
export const ACTIVATION_MODAL_KEY = "showActivationModal";
export const ACTIVATION_LOADING_KEY = "showActivationLoadingScreen";
export const ACTIVATION_CONFIRMATION_MODAL_KEY =
  "showActivationConfirmationModal";

export const useSessionStorage = <T extends NonNullable<unknown>>(
  key: string,
) => {
  const get = ({ onErrorValue }: { onErrorValue: T }): T | null => {
    try {
      return JSON.parse(
        browserSessionStorage.getItem(key) ?? "null",
      ) as T | null;
    } catch {
      console.warn(`Unable to access session storage for key "${key}".`);
      return onErrorValue;
    }
  };

  const set = (value: T) => {
    try {
      browserSessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      console.warn(`Unable to access session storage for key "${key}".`);
    }
  };

  const remove = () => {
    try {
      browserSessionStorage.removeItem(key);
    } catch {
      console.warn(`Unable to access session storage for key "${key}".`);
    }
  };

  return {
    get,
    set,
    remove,
  };
};
